
import { AxiosResponse } from 'axios';
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { IFile } from '../../../types/api/file';
import { TResponse } from "../../../types/common";


export async function saveFile(data: FormData): Promise<AxiosResponse<TResponse<IFile>>> {
    return axios.post<TResponse<IFile>>(API_ENDPOINTS.FILE_SAVE, data, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    })
}

export async function deleteFile(data: { url: string }): Promise<AxiosResponse<TResponse<null>>> {
    return axios.post<TResponse<null>>(API_ENDPOINTS.FILE_DELETE, data)
}

